import { appendReloadTimestamp, countReloadTimestamps } from './storageSync';

const HALT_WINDOW_MS = 20_000; // M=20s
const HALT_COUNT = 8;          // N=8 reloads within M → HALT

export function renderHaltScreen(): void {
  try {
    document.body.innerHTML = `
      <div style="
        position:fixed;inset:0;display:flex;flex-direction:column;align-items:center;
        justify-content:center;background:#f8f9fa;font-family:sans-serif;z-index:99999;
        padding:24px;text-align:center;
      ">
        <div style="max-width:480px;">
          <div style="font-size:48px;margin-bottom:16px;">⚠️</div>
          <h1 style="font-size:20px;font-weight:700;color:#1a1a1a;margin:0 0 12px;">
            読み込みを一時停止しました
          </h1>
          <p style="font-size:14px;color:#555;line-height:1.6;margin:0 0 24px;">
            短時間に多数の再読み込みを検出しました。<br>
            しばらく待ってから手動で再試行してください。
          </p>
          <button
            onclick="window.location.reload()"
            style="
              padding:10px 28px;font-size:14px;font-weight:600;border-radius:8px;
              border:none;background:#0a7a72;color:#fff;cursor:pointer;
            "
          >
            手動で再試行
          </button>
        </div>
      </div>
    `;
  } catch {
    // fail-safe: if DOM manipulation fails, silently drop
  }
}

export const BootstrapGuard = {
  check(): boolean {
    try {
      const now = Date.now();
      // Append this bootstrap event (self-clearing: next read prunes entries > 20s old)
      appendReloadTimestamp(now, HALT_WINDOW_MS);
      const count = countReloadTimestamps(HALT_WINDOW_MS, now);
      if (count > HALT_COUNT) {
        renderHaltScreen();
        return false;
      }
      return true;
    } catch {
      // A4: fail-open — guard exceptions must never crash the app
      return true;
    }
  },
};
